import { render, staticRenderFns } from "./LdapSetting.vue?vue&type=template&id=60f4a244&scoped=true&"
import script from "./LdapSetting.vue?vue&type=script&lang=js&"
export * from "./LdapSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4a244",
  null
  
)

export default component.exports